import { Component,NgModule, OnInit, Input, Output, EventEmitter} from '@angular/core';
import { Router} from "@angular/router";
import {PasswordModule,RadioButtonModule,ButtonModule,InputTextModule, PanelModule} from "primeng/primeng";
import {FormsModule, FormGroup, ReactiveFormsModule, FormBuilder, FormControl, Validators} from "@angular/forms";
import {HttpModule} from "@angular/http";
import {BrowserModule} from "@angular/platform-browser";
import {CommonModule} from "@angular/common";
import {MamAdminService} from './service/mam_service.component';
import { CookieService } from 'angular2-cookie/core';
import {Logger, Options, Level } from "angular2-logger/core";
import {TranslatePipeMoudle} from "./translate/translate.module.pipe";
import {TranslateServiceForm} from "./translate/translate.service"; // ADD THIS



@Component({
  selector: 'app-login',
  template:`
      <form [formGroup]="loginForm" (ngSubmit)="onSubmit(loginForm.value)" >
          <div class="loginBox">
            <div class="imgBox"></div>
            <div class="loginField">
              <h1>EXAFE MDM</h1>
              <p>{{'LANG_MDM_ManagerPage' | translate}}<br>{{'LANG_Enter_ID_Password' | translate}}</p>
              <input type="text" id="uid" formControlName="id" placeholder="Required" />
              <input type="password" id="ipw"  formControlName="password" placeholder="Required" >
              <!--<a type="submit" class="loginBtn" [disabled]="!loginForm.valid"><em>로그인</em></a>-->
              <button type="submit"  class="loginBtn ui-widget" [disabled]="!loginForm.valid"><em>{{'LANG_LogIn' | translate}}</em></button>
            </div>
          </div>
      </form>
 `
})
export class MamLoginComponent implements OnInit {
    loginForm : FormGroup;
    csrfValue : string;
    loginResult : any;
    translate : TranslateServiceForm;

    constructor(private  router: Router, private fb: FormBuilder, private service :MamAdminService, private cookie : CookieService, private logger : Logger, private _translate : TranslateServiceForm){
        _translate.use("ko");
        this.translate = _translate;
        this.loginForm = this.fb.group({
          'id' : new FormControl('',Validators.required),
          'password' : new FormControl('',Validators.required),
        });
    }
    ngOnInit() {

    }

    loginAction(data:any) {
      this.service.loginAction(data).subscribe(
          value => {
            this.loginResult = value;
            var httpStatus = value.json().statusCode;
            this.logger.debug("jsonData :", value.json());

            if(httpStatus == 200) {

              this.logger.debug("[Successful Login for super Admin ]");

              this.router.navigate(['/home']);
            } else if(httpStatus == 201 ) {
              let url = this.service.getUrl()+"/self";
              this.logger.debug("url",url);
              window.location.href=url;
              
            } else if(httpStatus == 407) {
              alert(this.translate.instant('LANG_AdminLockedUserMessage'));
            } else if(httpStatus == 402) {
              alert("해당 유저는 잠금상태입니다. 관리자에게 문의하세요.");
            } else {
              alert(this.translate.instant('ERROR_Login_Failed'));
            }

          },
          error => {
            this.logger.error("-- error : " + error);
          },
          () => {

          }
      )
    }

    onSubmit(data){
      let loginData = {'m_username': data.id, 'm_password':data.password};
      this.loginAction(loginData);
    }

}

@NgModule({
  imports:[PanelModule,CommonModule,BrowserModule,HttpModule,FormsModule,RadioButtonModule,InputTextModule,ButtonModule,PasswordModule, ReactiveFormsModule, TranslatePipeMoudle],
  declarations:[MamLoginComponent],
  exports:[MamLoginComponent],
  providers:[MamAdminService]
})
export class MamLoginModule{

}



// WEBPACK FOOTER //
// C:/Users/sung/WebstormProjects/exafe front/src/app/mam_login.component.ts